import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';

const initialState = {
  favorites: false,
};

const favoritesReducer = createReducer(initialState, (builder) =>
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;

    if (payload.resourceId === '/favorites-ms/sisal/spbc/v1/hasFavorites') {
      const hasFavorites = payload?.response?.data;
      state.favorites = hasFavorites;
    }
  }),
);

export default favoritesReducer;
